import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

const initialState = {
value: {
    //reviewModal
    //contactModal
}
}

export const displayModal = createSlice({
name: 'displayModal',
initialState,
reducers: {
    showModal: (state, action: PayloadAction<any>) => {
    state.value = { [action.payload]: true}
    },
    closeModal: (state) => {
    state.value = {}
    },
},
})

export const { showModal, closeModal } = displayModal.actions
export const modalOptions = (state: RootState) => state.displayModal.value
export default displayModal.reducer
